import {
  SessionAuditListResponseSchema,
  type SessionAuditListQuery,
  type SessionAuditListResponse,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/** Admin-only. Lists auth/session audit events, filtered + paginated server-side. */
export const listSessionAudit = async (
  query: SessionAuditListQuery,
): Promise<SessionAuditListResponse> => {
  const { data } = await apiClient.get<unknown>('/session-audit', { params: query });
  return SessionAuditListResponseSchema.parse(data);
};
